import React from "react";
import { IonContent } from "@ionic/react";
import SitePhotos from "./SitePhotos";
import { SitePhoto } from "../models/SitePhoto";
import { User } from "../models/User";

interface Props {
    permitId: string;
    sitePhotos?: SitePhoto[];
    onSitePhotoCaptured: (dataUrl: string) => void;
    onSitePhotoDeleted: (sitePhotoId: string) => void;
    isReadOnly: boolean;
    ableToAddPhotos: boolean;
    permitRegisterUsers: User[];
}

const PermitSitePhotosTab: React.FC<Props> = ({
    permitId,
    sitePhotos,
    onSitePhotoCaptured,
    onSitePhotoDeleted,
    isReadOnly,
    ableToAddPhotos,
    permitRegisterUsers,
}) => {
    return (
        <IonContent>
            <SitePhotos
                permitId={permitId}
                isReadOnly={isReadOnly}
                sitePhotos={sitePhotos}
                onSitePhotoCaptured={onSitePhotoCaptured}
                onSitePhotoDeleted={onSitePhotoDeleted}
                ableToAddPhotos={ableToAddPhotos}
                permitRegisterUsers={permitRegisterUsers}
            />
        </IonContent>
    );
};

export default PermitSitePhotosTab;
